import { Category } from '@/@types/category';
import { ColumnDefinitionType } from '@/components/common/Table/table.utils';
import { CategoriesTableActions } from './CategoriesTableActions';

export const CategoriesTableColumns: ColumnDefinitionType<Category>[] = [
  {
    key: 'name',
    header: 'Nome',
    sort: 'name',
  },
  {
    key: 'createdAt',
    header: 'Criado em',
    sort: 'created_at',
  },
  {
    key: 'id',
    header: 'Ações',
    render: CategoriesTableActions,
    width: '5rem',
    align: 'center',
    sticky: 'right',
  },
];
